/**
 * Whether the value is an absolute http(s) url, read exactly as it is written.
 *
 * A url parser drops a space before or after the url and still calls it a url; a pattern on the raw string does not. Whoever tells a url from a key, and whoever then sends it as one, asks this, so the two cannot come to different answers about the same cell. A url holds no whitespace - a presigned one is
 * percent-encoded - so any at all, before, inside or after, means it is not one.
 */
export function isHttpUrl(value: unknown): value is string {
	if (typeof value !== 'string' || !/^https?:\/\/\S+$/i.test(value)) {
		return false;
	}

	try {
		const url = new URL(value);
		return url.protocol === 'https:' || url.protocol === 'http:';
	} catch {
		return false;
	}
}

/** Whether the value is an {@link isHttpUrl} over https. */
export function isHttpsUrl(value: unknown): value is string {
	return isHttpUrl(value) && /^https:/i.test(value);
}
